const USEFUL_ACTION_KEY = 'deadbird-useful-actions';

export const getUsefulActionCount = (): number => Number(localStorage.getItem(USEFUL_ACTION_KEY) || 0);

export const markUsefulAction = (): void => {
  const nextCount = getUsefulActionCount() + 1;
  localStorage.setItem(USEFUL_ACTION_KEY, String(nextCount));
  window.dispatchEvent(new CustomEvent('deadbird-useful-action', { detail: nextCount }));
};
